import { render, staticRenderFns } from "./ajuda.vue?vue&type=template&id=7d83038c&scoped=true&"
import script from "./ajuda.vue?vue&type=script&lang=js&"
export * from "./ajuda.vue?vue&type=script&lang=js&"
import style0 from "./ajuda.vue?vue&type=style&index=0&id=7d83038c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d83038c",
  null
  
)

export default component.exports